
import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { externalEntityGroups } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import { LanguageConsumer } from '../../../LanguageContext'
import ExternalEntityGroupsContent from '../../../components/Dashboard/Subscription/ExternalEntityGroupsContent'
import { ExternalEntityGroupConsumer, ExternalEntityGroupProvider } from '../../../ExternalEntityGroupContext'


const ExternalEntityGroups = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.ExternalEntityGroups' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={externalEntityGroups.image}
        description={intl.formatMessage({ id: 'Sidebar.Links.ExternalEntityGroups' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length &&
              <>
                {!!userData.is_admin ?
                  <Layout content={
                  <LanguageConsumer>
                    {({ locale }) => (
                      <ExternalEntityGroupProvider  handleNotificationCall={handleNotificationCall}>
                        <ExternalEntityGroupConsumer>
                          {({ externalServiceHandlers, getExternalServiceHandlers }) => (
                            <ExternalEntityGroupsContent
                              handleNotificationCall={handleNotificationCall}
                              locale={locale}
                              externalServiceHandlers={externalServiceHandlers}
                              getExternalServiceHandlers={getExternalServiceHandlers}
                            />
                          )}
                        </ExternalEntityGroupConsumer>
                      </ExternalEntityGroupProvider>
                    )}
                  </LanguageConsumer>} /> :
                  (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                }
              </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default ExternalEntityGroups

